<template>
  <div class="mx-auto text-center">
    <v-carousel hide-delimiters :height="carouselHeight" v-model="selected">

      <template v-if="!mobile">
        <v-carousel-item>
          <v-row
            class="fill-height"
            align="center"
            justify="center"
          >
            <v-card light flat color="transparent" elevation="10" max-width="800" class="mx-auto">
              <v-img max-width="800"
                     :src="require(`@/assets/landing/stats/stat_map_${this.$vuetify.lang.current}.png`)"
                     eager></v-img>
            </v-card>
          </v-row>

          <!--          <v-img contain max-height="650" min-height="500"-->
          <!--                 :src="require(`@/assets/landing/stats/stat_map_${this.$vuetify.lang.current}.png`)"></v-img>-->
        </v-carousel-item>
      </template>
      <template v-else>
        <v-carousel-item>
          <v-row
            class="fill-height"
            align="center"
            justify="center"
          >
            <v-card light flat color="transparent" elevation="10" max-width="800" class="mx-auto">
              <v-img  max-width="800"
                     :src="require(`@/assets/landing/stats/stat_map_${this.$vuetify.lang.current}_mobile.png`)"
                     eager></v-img>
            </v-card>
          </v-row>
<!--          <v-img contain max-height="650" min-height="500"-->
<!--                 :src="require(`@/assets/landing/stats/stat_map_${this.$vuetify.lang.current}_mobile.png`)"></v-img>-->
        </v-carousel-item>
      </template>

      <template v-if="!mobile">
        <v-carousel-item>
          <v-row
            class="fill-height"
            align="center"
            justify="center"
          >
            <v-card light flat color="transparent" elevation="10" max-width="700" class="mx-auto">
              <v-img contain max-width="700"
                     :src="require(`@/assets/landing/stats/stat_basic_${this.$vuetify.lang.current}.png`)"
                     eager></v-img>
            </v-card>
          </v-row>
<!--          <v-img contain max-height="650" min-height="400"-->
<!--                 :src="require(`@/assets/landing/stats/stat_basic_${this.$vuetify.lang.current}.png`)"></v-img>-->
        </v-carousel-item>
      </template>
      <template v-else>
        <v-carousel-item>
          <v-row
            class="fill-height"
            align="center"
            justify="center"
          >
            <v-card light flat color="transparent" elevation="10" max-width="800" class="mx-auto">
              <v-img contain max-width="800"
                     :src="require(`@/assets/landing/stats/stat_basic_${this.$vuetify.lang.current}_mobile.png`)"
                     eager></v-img>
            </v-card>
          </v-row>
<!--          <v-img contain max-height="650" min-height="400"-->
<!--                 :src="require(`@/assets/landing/stats/stat_basic_${this.$vuetify.lang.current}_mobile.png`)"></v-img>-->
        </v-carousel-item>
      </template>

    </v-carousel>
    <span class="mx-auto body-1 font-italic font-weight-light">
      {{ $vuetify.lang.t(`$vuetify.landing.functionality.stats.labels[${selected}]`) }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'statsCarousel',
  data: () => ({
    selected: 0
  }),
  computed: {
    carouselHeight () {
      if (this.mobile) {
        return 550
      } else {
        return 650
      }
    },
    mobile () {
      return ['xs', 'sm'].includes(this.$vuetify.breakpoint.name)
    }
  }
}
</script>

<style scoped>

</style>
